import { AxiosError } from "axios";
import customAxios from "config";
import { globalJson } from "global/global_json";

export const ProfileChangeFun = async (
  payload: any
): Promise<{ data?: any; error?: string }> => {
  try {
    const response = await customAxios.patch("/api/my-profile/", payload, {
      headers: {
        "Content-Type": "multipart/form-data", // Ensure the request is sent as multipart
      },
    });
    console.log(response.data);
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      console.log(error);
      return {
        error:
          error.response.data.error ||
          "An error occurred during profile update.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};

export const ContactFun = async (payload: {
  company: any;
  name: string;
  email: string;
  message: string;
}): Promise<{ data?: any; error?: string }> => {
  try {
    // Create a FormData object to hold the name, email, and message
    const formData = new FormData();
    formData.append("name", payload.name);
    formData.append("email", payload.email);
    formData.append("message", payload.message);
    formData.append("company", payload.company || ""); // Append company if available
    const response = await customAxios.post(
      "/api/company/contact-us/",
      formData
    );
    return { data: response.data }; // Return response data if successful
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      return {
        error:
          error?.response?.data?.error ||
          "An error occurred during profile update.",
      };
    }
    return { error: "An unknown error occurred." };
  }
};